export const widgetsConstants = {
  SHOW_FULLSCREEN_OVERLAY: "SHOW_FULLSCREEN_OVERLAY",
  HIDE_FULLSCREEN_OVERLAY: "HIDE_FULLSCREEN_OVERLAY"
};

export function showFullScreenOverlay(params) {
  return (dispatch) => {
    dispatch({
      type: widgetsConstants.SHOW_FULLSCREEN_OVERLAY,
      payload: params
    });
  };
}

export function hideFullScreenOverlay() {
  return (dispatch) => {
    dispatch({
      type: widgetsConstants.HIDE_FULLSCREEN_OVERLAY
    });
  };
}
